export default __webpack_public_path__ + "static/media/_DSC0264.1d683dec.JPG";